import React from 'react';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  padding1: {
    paddingLeft: 20,
    paddingRight: 20,
  },
  indentation: {
    textIndent: 50,
  },
}));
function PrivacyPolicy() {
  const classes = useStyles();
  return (
    <div className={classes.padding1}>
      <article>
        <section>
          <Typography variant="h3">Privacy Policy</Typography>
          <br></br>
        </section>
        <section>
          <Typography variant="body1">
            Welcome to our Privacy Policy.
          </Typography>
          <Typography variant="body1">
            Your privacy is critically important to us.
          </Typography>
          <br />
          <Typography variant="body1">
            Together Technologies, Inc. is located at:
          </Typography>
          <Typography variant="body1">Together Technologies, Inc.</Typography>
          <Typography variant="body1">Phone: 4047712391</Typography>
          <Typography variant="body1">
            <Link href="mailto:contact@2gathers.com">contact@2gathers.com</Link>
          </Typography>
        </section>
        <br />
        <section>
          <Typography variant="body1" align="justify">
            <p className={classes.indentation}>
              It is Together’s policy to respect your privacy regarding any
              information we may collect while operating our website. This
              Privacy Policy applies to{' '}
              <Link href="https://2gathers.com" target="_blank">
                https://www.2gathers.com
              </Link>
              (hereinafter, “us”, “we”, or “https://www.2gathers.com”). We
              respect your privacy and are committed to protecting personally
              identifiable information you may provide us through the Website.
              We have adopted this privacy policy (“Privacy Policy”) to explain
              what information may be collected on our Website, how we use this
              information, and under what circumstances we may disclose the
              information to third parties. This Privacy Policy applies only to
              information we collect through the Website and does not apply to
              our collection of information from other sources.
            </p>
            <p className={classes.indentation}>
              This Privacy Policy, together with the Terms and conditions posted
              on our Website, set forth the general rules and policies governing
              your use of our Website. Depending on your activities when
              visiting our Website, you may be required to agree to additional
              terms and conditions.
            </p>
            <br />
            <Typography variant="h6">
              Website Visitors
              <br></br>
            </Typography>
            <br></br>
            <div className={classes.indentation}>
              Like most website operators, Together Technologies, Inc. collects
              non-personally-identifying information of the sort that web
              browsers and servers typically make available, such as the browser
              type, language preference, referring site, and the date and time
              of each visitor request. Together’s purpose in collecting
              non-personally identifying information is to better understand how
              Together’s visitors use its website. From time to time, Together
              may release non-personally-identifying information in the
              aggregate, e.g., by publishing a report on trends in the usage of
              its website.
            </div>
            <br></br>
            <div className={classes.indentation}>
              Together also collects potentially personally-identifying
              information like Internet Protocol (IP) addresses for logged in
              users and for users leaving comments on{' '}
              <Link href="https://2gathers.com" target="_blank">
                https://www.2gathers.com
              </Link>{' '}
              blog posts. Together only discloses logged in user and commenter
              IP addresses under the same circumstances that it uses and
              discloses personally-identifying information as described below.
            </div>
            <br />
            <Typography variant="h6">
              Gathering of Personally-Identifying Information
              <br></br>
            </Typography>
            <br></br>
            <div className={classes.indentation}>
              Certain visitors to Together’s websites choose to interact with
              Together Technologies in ways that require Together Technologies
              to gather personally-identifying information. The amount and type
              of information that Together Technologies gathers depends on the
              nature of the interaction. For example, we ask visitors who sign
              up for a blog at{' '}
              <Link href="https://2gathers.com" target="_blank">
                https://www.2gathers.com
              </Link>{' '}
              to provide a username and email address.
            </div>
            <div>
              You directly provide our company with most of the data we collect.
              We collect and data when you
            </div>
            <ul>
              <li>
                <div>Register online to watch an event or host an event</div>
              </li>
              <li>
                <div>When you interact with other users on the platform</div>
              </li>
              <li>
                <div>
                  When you request any of our freely downloadable documents
                </div>
              </li>
              <li>
                <div>When you request any of our free services</div>
              </li>
              <li>
                <div>Use or view our website via your browser’s cookies</div>
              </li>
            </ul>
            <br></br>
            <div>
              We embed a Facebook widget to allow you to see number of
              likes/shares/recommends and “like/share/recommend” our webpages.
              This widget may collect your IP address, your web browser User
              Agent, store and retrieve cookies on your browser, embed
              additional tracking, and monitor your interaction with the widget,
              including correlating your Facebook account with whatever action
              you take within the widget (such as “liking/sharing/recommending”
              our webpage), if you are logged in to Facebook. For more
              information about how this data may be used, please see Facebook’s
              data privacy policy: https://www.facebook.com/about/privacy/update
            </div>
            <div>
              We use a Twitter Tweet widget at our website. As a result, our
              website makes requests to Twitter’s servers for you to be able to
              tweet our webpages using your Twitter account. These requests make
              your IP address visible to Twitter, who may use it in accordance
              with their data privacy policy:
              https://twitter.com/en/privacy#update
            </div>
            <div>
              We use a GooglePlus widget at our website. As a result, our
              website makes requests to Google’s servers for you to be able to
              share our webpages using your GooglePlus account. These requests
              make your IP address visible to Google, who may use it in
              accordance with their data privacy policy:
              https://policies.google.com/privacy
            </div>
            <div>
              We use a Linkedin Share widget at our website to allow you to
              share our webpages on Linkedin. These requests may track your IP
              address in accordance with their data privacy policy:
              https://www.linkedin.com/legal/privacy-policy
            </div>
            <div>
              We use Pinterest Save widget at our website to allow you to pin
              images to Pinterest from our webpages. These requests may track
              your IP address in accordance with their data privacy policy:
              https://policy.pinterest.com/en/privacy-policy
            </div>
            <div>
              We use StumbleUpon Badge widget at our website which may log
              information when you interact with the widget. Log Data is a form
              of Non-Identifying Information, in accordance with their privacy
              policy: http://www.stumbleupon.com/privacy
            </div>
            <div>
              We use Reddit Badge widget at our website which may log
              information when you interact with the widget. This may include
              your IP address, user-agent string, browser type, operating
              system, referral URLs, device information (e.g., device IDs),
              pages visited, links clicked, user interactions (e.g., voting
              data), the requested URL and hardware settings, in accordance with
              their privacy policy:
              https://www.redditinc.com/policies/privacy-policy
            </div>
            <div>
              We use Xing Share widget at our website to allow you to share our
              webpages on Xing and this let Xing collate data about you
              automatically by means of tracking, in accordance with their
              privacy policy: https://privacy.xing.com/en/privacy-policy
            </div>
            {/* <div>
              We use Twilio chat and streaming widgets at our website to allow
              you to host and watch events on our website, Twilio stores data in
              accordance with their privacy policy:
              https://www.twilio.com/legal/privacy
            </div> */}
            <br />
            <Typography variant="h6">How will we use your data?</Typography>
            <br />
            <div>Our Company collects your data so that we can:</div>
            <div>Process your order and manage your account.</div>
            <div>Send you event information and tickets</div>
            <div>
              Email you with special offers about events we think you might
              like.
            </div>
            <div>
              When Our Company processes your order, it may use your data to get
              information from search engines and other marketing tools and use
              the resulting information to render a service to you.
            </div>
            <br />
            <Typography variant="h6">
              What are your data protection rights?
            </Typography>
            <br />
            <div>
              Our Company would like to make sure you are fully aware of all of
              your data protection rights. Every user is entitled to the
              following:
            </div>
            <div>
              The right to access – You have the right to request Our Company
              for copies of your personal data. We may charge you a small fee
              for this service.
            </div>
            <div>
              The right to rectification – You have the right to request that
              Our Company correct any information you believe is inaccurate. You
              also have the right to request Our Company to complete the
              information you believe is incomplete.
            </div>
            <div>
              The right to erasure – You have the right to request that Our
              Company erase your personal data, under certain conditions.
            </div>
            <div>
              The right to restrict processing – You have the right to request
              that Our Company restrict the processing of your personal data,
              under certain conditions.
            </div>
            <div>
              The right to object to processing – You have the right to object
              to Our Company’s processing of your personal data, under certain
              conditions.
            </div>
            <div>
              The right to data portability – You have the right to request that
              Our Company transfer the data that we have collected to another
              organization, or directly to you, under certain conditions.
            </div>
            <div>
              If you make a request, we have one month to respond to you.
            </div>
            <br />
            <Typography variant="h6">Information Disclosure</Typography>
            <br />
            <div className={classes.indentation}>
              We do not sell or rent personal information, including personally
              identifiable information, to any unrelated third parties. We
              disclose personal information provided to us in limited
              circumstances as may be described in this privacy policy. These
              circumstances include, but are not limited to, the following: (a)
              to the extent required by law or to respond to judicial or
              governmental process or a good faith belief that such action is
              necessary to comply with law or legal process; (b) to protect the
              security and integrity of the Websites and 2gathers streaming; (c)
              to protect our rights and property and the rights and property of
              others; (d) to take precautions against liability; (e) to respond
              to claims that submitted information violates the rights or
              interests of third parties or defend against other legal claims;
              (f) to correct technical problems and malfunctions in how the
              Websites operate or process visitors’ information; (g) in
              connection with a merger, consolidation or sale of all or
              substantially all of the stock or assets of one or more of our
              businesses; (h) within 2gathers streaming for purposes of data
              processing or storage, if applicable; or (i) as necessary
              (including as required pursuant to our service agreements with our
              customers) with business partners, service vendors, authorized
              third-party agents or contractors solely to the extent required
              for such parties to provide a requested service or transaction in
              connection with 2gathers’s services and for no other purpose.
            </div>
            <br />
            <Typography variant="h6">
              Access to Personal Information; Opt-Out Preferences
            </Typography>
            <br />
            <div className={classes.indentation}>
              Individuals seeking access to their personal information that we
              collected directly from an individual, whether to confirm such
              information, update it or request removal or other changes, may
              contact 2gathers through an email or the opt-out form that we have
              on our website. We will respond to your request within a
              reasonable timeframe if contacted via email. The opt-out process
              takes place immediately if you use the unsubscribe link included
              with every email communication. We require our customers to comply
              with applicable privacy laws and regulations pertaining to the use
              of 2gathers services including, but not limited to, that all
              messages sent by our event hosts streaming through 2gathers, in
              whatever medium, contain the valid name and required contact
              information for the customer.
            </div>
            <br />
            <Typography variant="h6">Advertisements</Typography>
            <br />
            <div className={classes.indentation}>
              Ads appearing on our website may be delivered to users by
              advertising partners, who may set cookies. These cookies allow the
              ad server to recognize your computer each time they send you an
              online advertisement to compile information about you or others
              who use your computer. This information allows ad networks to,
              among other things, deliver targeted advertisements that they
              believe will be of most interest to you. This Privacy Policy
              covers the use of cookies by Together Technologies and does not
              cover the use of cookies by any advertisers.
            </div>
            <br />
            <Typography variant="h6">Chat</Typography>
            <div className={classes.indentation}>
              We use video chat and text chat features to help enhancing your
              online event experience. The chat functionality will share your
              name, email address and telephone number to the Twilio chat server
              which is our provider of chat functionality. We do not store any
              of this chat data on our servers. Please read Twilio’s data
              protection and privacy [policies here:
              <Link
                href="https://www.twilio.com/legal/data-protection-addendum "
                target="_blank"
              >
                https://www.twilio.com/legal/data-protection-addendum
              </Link>{' '}
              and{' '}
              <Link
                href="https://www.twilio.com/legal/privacy
"
                target="_blank"
              >
                https://www.twilio.com/legal/privacy
              </Link>
            </div>
            <br />
            <Typography variant="h6">Security</Typography>
            <br />
            <div className={classes.indentation}>
              We are committed to protecting the both your personal data and
              video streaming data using a combination of industry-standard
              end-to-end encryption and other security mechanisms. We take
              layered protective measures to prevent unauthorized access or use
              of your personal data. Payments are processed on third party
              websites such as Paypal and Stripe which have strictest security
              measures implemented. Transfer of data between 2gathers and 3rd
              party websites are encrypted over security protocols such as SSL
              and TLS.
            </div>
            <div className={classes.indentation}>
              The security of your Personal Information is important to us, but
              remember that no method of transmission over the Internet, or
              method of electronic storage is 100% secure. While we strive to
              use commercially acceptable means to protect your Personal
              Information, we cannot guarantee its absolute security. Our
              Company securely stores your data at our CRM software provider.
              You can read more by clicking here. Our Company will keep your
              personal for 12 months. Once this time period has expired, we will
              delete your data by removing your from the database and mailing
              lists.
            </div>
            <br />
            <Typography variant="h6">Children</Typography>
            <br />
            <div>
              We are committed to protect children’s privacy rights and are
              COPPA compliant. Our policy towards PIA for children under 13
              years of age, is described below
            </div>
            <ul>
              <li>
                We do not collect personal contact
                information from children without the consent of a parent or
                legal guardian, except in limited circumstances authorized by
                law
              </li>
              <li>
                We may collect some information like IP address, operating
                system, etc which are automatically sent by the browser and use
                such information along with cookies to provide functionality and
                support. We obtain consent where required.
              </li>
              <li>
                We do not ask for more personal information than is necessary
                for a child to participate in an activity.
              </li>
              <li>
                We take steps to prevent children from posting or publicly
                disclosing personal information.
              </li>
              <li>
                We use monitoring and filtering technology in an effort to
                prevent children from posting personal information without
                parental consent..
              </li>
            </ul>
            <br />
            <Typography variant="h6">Links To External Sites</Typography>
            <br />
            <div className={classes.indentation}>
              Our Service may contain links to external sites that are not
              operated by us. If you click on a third party link, you will be
              directed to that third party’s site. We strongly advise you to
              review the Privacy Policy and terms and conditions of every site
              you visit.
            </div>
            <div>
              We have no control over, and assume no responsibility for the
              content, privacy policies or practices of any third party sites,
              products or services.
            </div>
            <br />
            <Typography variant="h6">Aggregated Statistics</Typography>
            <br />
            <div className={classes.indentation}>
              Together Technologies may collect statistics about the behavior of
              visitors to its website. Together Technologies may display this
              information publicly or provide it to others. However, Together
              Technologies does not disclose your personally-identifying
              information.
            </div>
            <br />
            <Typography variant="h6">Cookies</Typography>
            <br />
            <div className={classes.indentation}>
              To enrich and perfect your online experience, Together
              Technologies uses “Cookies”, similar technologies and services
              provided by others to display personalized content, appropriate
              advertising and store your preferences on your computer.
            </div>
            <div>
              A cookie is a string of information that a website stores on a
              visitor’s computer, and that the visitor’s browser provides to the
              website each time the visitor returns. Together Technologies uses
              cookies to help Together Technologies identify and track visitors,
              their usage of{' '}
              <Link href="https://2gathers.com" target="_blank">
                https://www.2gathers.com
              </Link>
              , and their website access preferences. Together Technologies
              visitors who do not wish to have cookies placed on their computers
              should set their browsers to refuse cookies before using
              Together’s websites, with the drawback that certain features of
              Together’s websites may not function properly without the aid of
              cookies.
            </div>
            <div>
              By continuing to navigate our website without changing your cookie
              settings, you hereby acknowledge and agree to Together’s use of
              cookies.
            </div>
            <br />
            <Typography variant="h6">
              What types of cookies do we use?
            </Typography>
            <br />
            <div className={classes.indentation}>
              There are a number of different types of cookies, however, our
              website uses:
            </div>
            <div>
              Functionality – Our Company uses these cookies so that we
              recognize you on our website and remember your previously selected
              preferences. These could include what language you prefer and
              location you are in. A mix of first-party and third-party cookies
              are used.
            </div>
            <div>
              Advertising – Our Company uses these cookies to collect
              information about your visit to our website, the content you
              viewed, the links you followed and information about your browser,
              device, and your IP address. Our Company sometimes shares some
              limited aspects of this data with third parties for advertising
              purposes. We may also share online data collected through cookies
              with our advertising partners. This means that when you visit
              another website, you may be shown advertising based on your
              browsing patterns on our website.
            </div>
            <br />
            <Typography variant="h6">Privacy Policy Changes</Typography>
            <br />
            <div className={classes.indentation}>
              Although most changes are likely to be minor, Together
              Technologies may change its Privacy Policy from time to time, and
              in Together’s sole discretion. Together Technologies encourages
              visitors to frequently check this page for any changes to its
              Privacy Policy. Your continued use of this site after any change
              in this Privacy Policy will constitute your acceptance of such
              change.
            </div>
          </Typography>
        </section>
      </article>
    </div>
  );
}

export default PrivacyPolicy;
